/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import { useEffect, useState } from "react";
import { changeTopNavigationElements } from "../slices/navigationPanel/navigationPanelSlice";
import { changeTabMenu } from "../slices/tabPane/tabPaneSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import Spinner from "../components/Spinner";
import StringEntry from "../datatypeComponents/StringEntry";
import IdEntry from "../datatypeComponents/IdEntry";
import CodeArrayEntry from "../datatypeComponents/CodeArrayEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import ReferenceEntry, { DisplayFromFHIRReference } from "../datatypeComponents/ReferenceEntry";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import BooleanEntry, { displayStringFromFHIRBoolean } from "../datatypeComponents/BooleanEntry";
import { DisplayFromFHIRUri } from "../datatypeComponents/UriEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";
import { componentLoadingOff, componentLoadingOffAll, componentLoadingOn, selectComponentLoading } from "../slices/globalLoading/globalLoadingSlice";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../slices/viewingOlderVersion/viewingOlderVersionSlice";

const ImplementationGuideDefinitionResourceEntry = ({
    elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed
}) => {

    const [resourceEntryState, setResourceEntryState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingResource = {
            "reference": "", "fhirVersion": [], "name": "", "description": "",
            "isExample": "", "profile": [], "groupingId": ""
        }
        if (startingValue) {
            if (startingValue.extension) { startingResource.extension = startingValue.extension; }
            if (startingValue.reference) { startingResource.reference = startingValue.reference; }
            if (startingValue.fhirVersion) { startingResource.fhirVersion = startingValue.fhirVersion; }
            if (startingValue.name) { startingResource.name = startingValue.name; }
            if (startingValue.description) { startingResource.description = startingValue.description; }
            if (typeof startingValue.isExample === "boolean") { startingResource.isExample = startingValue.isExample; }
            if (startingValue.profile) { startingResource.profile = startingValue.profile; }
            if (startingValue.groupingId) { startingResource.groupingId = startingValue.groupingId; }
        }
        setResourceEntryState(JSON.parse(JSON.stringify(startingResource)));
    }, []); 

    useEffect((() => {
        if (Object.keys(resourceEntryState).length > 0) {
            let newResourceEntry = {};
            if (resourceEntryState.extension) { newResourceEntry.extension = resourceEntryState.extension; }
            if (resourceEntryState.reference && Object.keys(resourceEntryState.reference).length > 0) {
                newResourceEntry.reference = resourceEntryState.reference;
            }
            if (resourceEntryState.fhirVersion?.length) {
                newResourceEntry.fhirVersion = resourceEntryState.fhirVersion;
            }
            if (resourceEntryState.name) { newResourceEntry.name = resourceEntryState.name; }
            if (resourceEntryState.description) { newResourceEntry.description = resourceEntryState.description; }
            if (typeof resourceEntryState.isExample === "boolean") {
                newResourceEntry.isExample = resourceEntryState.isExample;
            }
            if (resourceEntryState.profile?.length) {
                newResourceEntry.profile = resourceEntryState.profile;
            }
            if (resourceEntryState.groupingId) { newResourceEntry.groupingId = resourceEntryState.groupingId; }
            setResourceState(prevState => { return { ...prevState, [elementName]: newResourceEntry } });
        }
    }), [resourceEntryState]);

    if (startCollapsedState) {
        return <div>
            <p><b>{fieldLabel}: </b></p>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.reference &&
                    <p><b>Reference: </b><DisplayFromFHIRReference reference={startingValue.reference} /></p>}
                {startingValue.fhirVersion && <p><b>FHIR Version: </b>{startingValue.fhirVersion.join(", ")}</p>}
                {startingValue.name && <p><b>Name: </b>{startingValue.name}</p>}
                {startingValue.description && <div>
                    <b>Description: </b><DisplayFromFHIRMarkdown markdown={startingValue.description} />
                    <br /><br />
                </div>}
                {(typeof startingValue.isExample === "boolean") &&
                    <p><b>is Example: </b>{displayStringFromFHIRBoolean(startingValue.isExample)}</p>}
                {startingValue.profile && <p><b>Profile: </b>{startingValue.profile.join(", ")}</p>}
                {startingValue.groupingId && <p><b>Grouping id: </b>{startingValue.groupingId}</p>}
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(resourceEntryState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <ReferenceEntry elementName='reference' fieldLabel='Reference'
                    startingValue={resourceEntryState.reference} enableCreation={true} startCollapsed
                    setResourceState={setResourceEntryState} />
                <CodeArrayEntry elementName='fhirVersion' fieldLabel='FHIR Version'
                    allowedValues={['6.0.0-ballot3', '6.0.0-ballot2', '6.0.0-ballot1',
                        '6.0.0', '6.0', '5.0.0', '5.0', '4.6.0', '4.3.0']}
                    startingValue={resourceEntryState.fhirVersion}
                    setResourceState={setResourceEntryState}
                    dataEntryStyle="dropdownsearch" />
                <StringEntry elementName="name" fieldLabel="Name"
                    startingValue={resourceEntryState.name}
                    setResourceState={setResourceEntryState} />
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startingValue={resourceEntryState.description} startCollapsed
                    setResourceState={setResourceEntryState} />
                <BooleanEntry elementName='isExample' fieldLabel='is Example'
                    startingValue={resourceEntryState.isExample} setResourceState={setResourceEntryState} />
                <ArrayEntry datatype='canonical' elementName='profile'
                    fieldLabel='Profile'
                    startingValue={resourceEntryState.profile || []}
                    setResourceState={setResourceEntryState} />
                <IdEntry elementName='groupingId' fieldLabel='Grouping id'
                    startingValue={resourceEntryState.groupingId} setResourceState={setResourceEntryState} />
            </div>
        </>
    }
};

const ImplementationGuideDefinitionDisplay = ({ startingValue, setImplementationGuideResourceState }) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));

    const [definitionState, setDefinitionState] = useState({});

    const [implementationGuideReferencesState, setImplementationGuideReferencesState] = useState({
        "exampleReferences": [], "otherReferences": [], "loaded": false
    });

    useEffect(() => {
        let startingDefinition = {
            'grouping': [], 'resource': [], 'page': "", 'parameter': [], 'template': []
        };
        if (startingValue) {
            if (startingValue.extension) { startingDefinition.extension = startingValue.extension; }
            if (startingValue.grouping) { startingDefinition.grouping = startingValue.grouping; }
            if (startingValue.resource) { startingDefinition.resource = startingValue.resource; }
            if (startingValue.page) { startingDefinition.page = startingValue.page; }
            if (startingValue.parameter) { startingDefinition.parameter = startingValue.parameter; }
            if (startingValue.template) { startingDefinition.template = startingValue.template; }
        }
        let starterDefinitionValues = JSON.parse(JSON.stringify(startingDefinition));
        setDefinitionState(starterDefinitionValues);
        if (!implementationGuideReferencesState?.loaded) {
            dispatch(componentLoadingOn("ImplementationGuideDefinitionDisplay"));
            let exampleReferences = [];
            let otherReferences = [];
            if (starterDefinitionValues?.resource?.length > 0) {
                for (const resource of starterDefinitionValues.resource) {
                    let resourceReference = resource.reference;
                    resourceReference.type = resourceReference.reference.split("/")[0];
                    if (resource.name) {
                        resourceReference.display = resource.name;
                    }
                    if (resource.isExample) {
                        exampleReferences.push(resourceReference);
                    } else {
                        otherReferences.push(resourceReference);
                    }
                }
            }
            setImplementationGuideReferencesState({
                "exampleReferences": exampleReferences, "otherReferences": otherReferences, "loaded": true
            });
            dispatch(componentLoadingOff("ImplementationGuideDefinitionDisplay"));
        }
    }, []);

    useEffect(() => {
        if (Object.keys(definitionState).length > 0) {
            let newDefinition = {};
            if (definitionState.extension) { newDefinition.extension = definitionState.extension; }
            if (definitionState.grouping?.length) {
                newDefinition.grouping = definitionState.grouping;
            }
            if (definitionState.resource?.length) {
                newDefinition.resource = definitionState.resource;
            }
            if (definitionState.page && Object.keys(definitionState.page).length) {
                newDefinition.page = definitionState.page;
            }
            if (definitionState.parameter?.length) {
                newDefinition.parameter = definitionState.parameter;
            }
            if (definitionState.template?.length) {
                newDefinition.template = definitionState.template;
            }
            setImplementationGuideResourceState(prevState => { return { ...prevState, "definition": newDefinition } });
        }
    }, [definitionState]);

    useEffect(() => {
        if (implementationGuideReferencesState?.exampleReferences?.length) {
            let exampleResources = implementationGuideReferencesState.exampleReferences.map(reference => {
                let returnObject = {
                    "reference": { "reference": reference.reference },
                    "name": reference.display,
                    "isExample": true
                }
                return returnObject;
            });
            let otherResources = implementationGuideReferencesState.otherReferences?.map(reference => {
                let returnObject = {
                    "reference": { "reference": reference.reference },
                    "name": reference.display,
                    "isExample": false
                }
                return returnObject;
            }) || [];
            let newResourceArray = exampleResources.concat(otherResources);
            setDefinitionState(prevState => {
                return { ...prevState, "resource": newResourceArray }
            });
        }
    }, [implementationGuideReferencesState]);

    return <div>
        <h3 id="resources">Resources</h3>
        <div style={{ marginLeft: "24px" }}>
            {editMode ?
                <>
                    {implementationGuideReferencesState?.loaded && <>
                        <p>To manage the IG examples as a simple set of resource references:</p>
                        <div style={{ marginLeft: "24px" }}>
                            <ArrayEntry datatype='Reference' elementName='exampleReferences'
                                fieldLabel='Example Resource'
                                startingValue={implementationGuideReferencesState.exampleReferences || []}
                                startCollapsed startEmptyArrayClosed enableCreation={true}
                                setResourceState={setImplementationGuideReferencesState} />
                        </div>
                    </>}
                    <ArrayEntry datatype='ImplementationGuideDefinitionResource'
                        elementName='resource' startCollapsed deletable
                        fieldLabel='Resource' startingValue={definitionState.resource}
                        setResourceState={setDefinitionState} />
                </>
                :
                <>
                    {Array.isArray(definitionState.resource) && definitionState.resource.map((resource, resourceIndex) => {
                        return <div key={resourceIndex}>
                            <p><b>Resource {resourceIndex + 1}: </b></p>
                            <div style={{ marginLeft: "24px" }}>
                                {resource.reference &&
                                    <p><b>Reference: </b><DisplayFromFHIRReference reference={resource.reference} /></p>}
                                {resource.fhirVersion && <p><b>FHIR Version: </b>{resource.fhirVersion.join(", ")}</p>}
                                {resource.name && <p><b>Name: </b>{resource.name}</p>}
                                {resource.description && <div>
                                    <b>Description: </b><DisplayFromFHIRMarkdown markdown={resource.description} />
                                    <br /><br />
                                </div>}
                                {(typeof resource.isExample === "boolean") &&
                                    <p><b>is Example: </b>{displayStringFromFHIRBoolean(resource.isExample)}</p>}
                                {resource.profile && <p><b>Profile: </b>{resource.profile.join(", ")}</p>}
                                {resource.groupingId && <p><b>Grouping id: </b>{resource.groupingId}</p>}
                            </div>
                        </div>
                    })}
                </>
            }
        </div>
        <h3 id="pages">Pages</h3>
        <div style={{ marginLeft: "24px" }}>
            {editMode ?
                <p>Editing pages not yet available.</p>
                :
                <>{definitionState.page ?
                    <>
                        {definitionState.page.sourceUrl && <div>
                            <b>Source URL: </b><DisplayFromFHIRUri uri={definitionState.page.sourceUrl} />
                            <br /><br />
                        </div>}
                        {definitionState.page.sourceString && <p><b>Source: </b>{definitionState.page.sourceString}</p>}
                        {definitionState.page.sourceMarkdown && <div>
                            <b>Source: </b><DisplayFromFHIRMarkdown markdown={definitionState.page.sourceMarkdown} />
                            <br /><br />
                        </div>}
                        {definitionState.page.name && <p><b>Name: </b>{definitionState.page.name}</p>}
                        {definitionState.page.title && <p><b>Title: </b>{definitionState.page.title}</p>}
                        {definitionState.page.generation && <p><b>Generation: </b>{definitionState.page.generation}</p>}
                        {Array.isArray(definitionState.page.page) &&
                            definitionState.page.page.map((page, pageIndex) => {
                                return <div key={pageIndex}>
                                    <p><b>Page {pageIndex + 1}: </b></p>
                                    <div style={{ marginLeft: "24px" }}>
                                        {page.sourceUrl && <div>
                                            <b>Source URL: </b><DisplayFromFHIRUri uri={page.sourceUrl} />
                                            <br /><br />
                                        </div>}
                                        {page.sourceString && <p><b>Source: </b>{page.sourceString}</p>}
                                        {page.sourceMarkdown && <div>
                                            <b>Source: </b><DisplayFromFHIRMarkdown markdown={page.sourceMarkdown} />
                                            <br /><br />
                                        </div>}
                                        {page.name && <p><b>Name: </b>{page.name}</p>}
                                        {page.title && <p><b>Title: </b>{page.title}</p>}
                                        {page.generation && <p><b>Generation: </b>{page.generation}</p>}
                                        {page.page && <p><b>Contains nested pages</b></p>}
                                    </div>
                                </div>
                            })}
                    </>
                    :
                    <p>No page data.</p>
                }</>

            }
        </div>
    </div>
}

const ImplementationGuideDisplay = ({ foi }) => {
    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const displayTitle = parentResourceDetail?.displayTitle;
    const componentIsLoading = useSelector(selectComponentLoading);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));

    const [implementationGuideResourceState, setImplementationGuideResourceState] = useState({});

    useEffect(() => {
        dispatch(changeTopNavigationElements(["Settings", "Resources", "Pages"]));
        dispatch(changeBrowserTabTitle("FEvIR ImplementationGuide - " + displayTitle));
        dispatch(componentLoadingOn("ImplementationGuideDisplay"));
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setImplementationGuideResourceState(olderVersionJson);
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson) {
            setImplementationGuideResourceState(resourceJson);
        }
        dispatch(componentLoadingOffAll("ImplementationGuideDisplay"));
    }, [resourceJson]);

    useEffect(() => {
        dispatch(changeTool("FEvIR®: ImplementationGuide " + (editMode ? "Builder" : "Viewer")));
    }, [editMode]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousFinalValue = null;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = implementationGuideResourceState.title;
            newResourceDetail.displayTitle = implementationGuideResourceState.title ||
                implementationGuideResourceState.name || newResourceDetail.displayTitle;
            if (implementationGuideResourceState.title !== undefined &&
                previousFinalValue !== implementationGuideResourceState.title) {
                console.log("resourceUpdate for ImplementationGuide.title");
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [implementationGuideResourceState.title]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousFinalValue = null;
            previousFinalValue = newResourceDetail.revisedResourceJson.name;
            newResourceDetail.revisedResourceJson.name = implementationGuideResourceState.name;
            newResourceDetail.displayTitle = implementationGuideResourceState.title ||
                implementationGuideResourceState.name || newResourceDetail.displayTitle;
            if (implementationGuideResourceState.name !== undefined &&
                previousFinalValue !== implementationGuideResourceState.name) {
                console.log("resourceUpdate for ImplementationGuide.name");
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [implementationGuideResourceState.name]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousFinalValue = null;
            previousFinalValue = newResourceDetail.revisedResourceJson.packageId;
            newResourceDetail.revisedResourceJson.packageId = implementationGuideResourceState.packageId;
            if (implementationGuideResourceState.packageId !== undefined &&
                previousFinalValue !== implementationGuideResourceState.packageId) {
                console.log("resourceUpdate for ImplementationGuide.packageId");
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [implementationGuideResourceState.packageId]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousFinalValue = null;
            previousFinalValue = JSON.stringify(newResourceDetail.revisedResourceJson.fhirVersion);
            newResourceDetail.revisedResourceJson.fhirVersion = implementationGuideResourceState.fhirVersion;
            if (implementationGuideResourceState.fhirVersion !== undefined &&
                previousFinalValue !== JSON.stringify(implementationGuideResourceState.fhirVersion)) {
                console.log("resourceUpdate for ImplementationGuide.fhirVersion");
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [implementationGuideResourceState.fhirVersion]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousFinalValue = null;
            previousFinalValue = JSON.stringify(newResourceDetail.revisedResourceJson.definition);
            newResourceDetail.revisedResourceJson.definition = implementationGuideResourceState.definition;
            if (implementationGuideResourceState.definition !== undefined &&
                previousFinalValue !== JSON.stringify(implementationGuideResourceState.definition)) {
                console.log("resourceUpdate for ImplementationGuide.definition");
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [implementationGuideResourceState.definition]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <div>
        {componentIsLoading > 0 &&
            <Spinner />}
        <>{implementationGuideResourceState.id && <>
            <div style={{ marginTop: "12px" }}>
                <h3 id="settings">Settings</h3>
                <div style={{ marginLeft: "24px" }}>
                    {editMode ?
                        <StringEntry elementName="title" fieldLabel="Title"
                            startingValue={implementationGuideResourceState.title}
                            setResourceState={setImplementationGuideResourceState} />
                        :
                        <>{implementationGuideResourceState.title && <p><b>Title: </b>{implementationGuideResourceState.title}</p>}</>
                    }
                    {editMode ?
                        <StringEntry elementName="name" fieldLabel="Name"
                            startingValue={implementationGuideResourceState.name}
                            setResourceState={setImplementationGuideResourceState} />
                        :
                        <>{implementationGuideResourceState.name && <p><b>Name: </b>{implementationGuideResourceState.name}</p>}</>
                    }
                    {editMode ?
                        <IdEntry elementName="packageId" fieldLabel="Package Id"
                            startingValue={implementationGuideResourceState.packageId}
                            setResourceState={setImplementationGuideResourceState} />
                        :
                        <>{implementationGuideResourceState.name && <p><b>Package Id: </b>{implementationGuideResourceState.packageId}</p>}</>
                    }
                    {editMode ?
                        <CodeArrayEntry elementName='fhirVersion' fieldLabel='FHIR Version'
                            allowedValues={['6.0.0-ballot3', '6.0.0-ballot2', '6.0.0-ballot1',
                                '6.0.0', '6.0', '5.0.0', '5.0', '4.6.0', '4.3.0']}
                            startingValue={implementationGuideResourceState.fhirVersion}
                            setResourceState={setImplementationGuideResourceState}
                            dataEntryStyle="dropdownsearch" />
                        :
                        <>{implementationGuideResourceState.fhirVersion && <p><b>FHIR Version: </b>{implementationGuideResourceState.fhirVersion.join(", ")}</p>}</>
                    }
                </div>
                <ImplementationGuideDefinitionDisplay
                    startingValue={implementationGuideResourceState.definition}
                    setImplementationGuideResourceState={setImplementationGuideResourceState}
                />
            </div>
        </>}</>
    </div>
}

export default ImplementationGuideDisplay;
export { ImplementationGuideDefinitionResourceEntry };